// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"815e1be0","744":"e06f1677","801":"645f9123"}[chunkId] + ".chunk.js";
};